import { ContactUsLink } from '@app/dashboard/interfaces/contact-us.interface';
import { SvgIllustration } from '@smooved/ui';

export const contactUsLinks: ContactUsLink[] = [
    {
        icon: SvgIllustration.Mail,
        label: 'ADMIN.DASHBOARD.CONTACT_US.MAIL.LABEL',
        link: 'ADMIN.DASHBOARD.CONTACT_US.MAIL.LINK',
        extraInfo: 'ADMIN.DASHBOARD.CONTACT_US.EXTRA_INFO.ONE_DAY',
        contactType: 'Email',
    },
    {
        icon: SvgIllustration.Whatsapp,
        label: 'ADMIN.DASHBOARD.CONTACT_US.WHATSAPP.LABEL',
        link: 'ADMIN.DASHBOARD.CONTACT_US.WHATSAPP.LINK',
        contactType: 'Whatsapp',
    },
    {
        icon: SvgIllustration.Phone,
        label: 'ADMIN.DASHBOARD.CONTACT_US.PHONE.LABEL',
        link: 'ADMIN.DASHBOARD.CONTACT_US.PHONE.LINK',
        contactType: 'Phone',
    },
    {
        icon: SvgIllustration.LiveChat,
        label: 'ADMIN.DASHBOARD.CONTACT_US.LIVE_CHAT.LABEL',
        contactType: 'Chat',
    },
    {
        icon: SvgIllustration.Faq,
        label: 'ADMIN.DASHBOARD.CONTACT_US.FAQ.LABEL',
        link: 'ADMIN.DASHBOARD.CONTACT_US.FAQ.LINK',
        contactType: 'FAQ',
    },
];
